import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import urlData from '@shared/utilities/routes';
import { NavLink } from 'react-router-dom';

import styles from './CartIcon.module.scss';

export default function CartIcon() {
    return (
        <div className={styles['cart-icon-container']}>
            <NavLink
                to={urlData.checkout.mfeLink}
                className={styles['cart-icon']}
                aria-label={urlData.checkout.ariaLabel}>
                <ShoppingCartOutlinedIcon fontSize="medium" />
            </NavLink>
        </div>
    );
}
